<template>
  <v-dialog v-model="dialog" width="1200px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Fechar </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Importar dispositivos</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-file-input
              accept="*"
              label="File input"
              v-model="file"
            ></v-file-input>

            <v-btn class="primary" @click="importFile(file)">Load </v-btn>        <v-btn class="primary" @click="saveImport">Importar</v-btn>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th style="width: 300px" class="text-left">Código</th>
                  <th class="text-left">Descrição</th>

                  <th class="text-right">Adicionar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in objectsImport" v-bind:key="item.id">
                  <td>{{ item.code }}</td>
                  <td>{{ item.description }}</td>

                  <td class="text-right">
                    <!-- <v-btn class="primary" @click="addProduct(index)"
                        >+</v-btn
                      > -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="saveImport">Importar</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import Contact from "../../../../libraries/classes/Contact";
import hebelApi from "../../../../libraries/hebel/hebelApi";
import Module from '../../../../libraries/classes/devices/Module'

export default {
  components: {},
  name: "modal-import-contacts",
  props: ["dialog"],
  data() {
    return {
      objectsImport: [],
      file: null,
      contacts:[],
    };
  },

  watch: {},
  computed: {},
  created() {},
  async mounted() {
      this.contacts = await hebelApi.contacts.getAll();

  },

  methods: {
    close() {
      this.$emit("close");
    },
   
    async saveImport() {
      for (var a = 0; a < this.objectsImport.length; a++) {
        var d = this.objectsImport[a];

        await hebelApi.devices.upsert(d);

      }
         this.$emit("close");
      //this.dialog = false;
      //this.getAllDevices();
    },

     async importFile(file) {
      var json = await this.$globalFunctions.readFileAsync(file);
      console.log(json);
      this.objectsImport = JSON.parse(json);
      this.$forceUpdate();
    },
     close() {
      this.$emit("close");
    },



  },
};
</script>


<style scoped>
</style>